import { useState, useEffect } from 'react';
import { ForpoService } from '../service/ForpoService';




interface Props {
    idSelector: number;
    onChange: any;
    titulo: string;
}

export const SelectPolicy = ({ titulo, idSelector, onChange }: Props) => {

    const service = new ForpoService();
    const [lista, setLista] = useState([]);

    const [id, setID] = useState(idSelector ?? null);

    useEffect(() => {
        getLista();
    }, [idSelector])

    useEffect(() => {
        onChange(id);
    }, [id])

    const setValue = (e: any) => {
        setID(parseInt(e));
        onChange(id);
    }

    const getLista = () => {
        let properties = {
            State: 1,
            IsActive: 1,
        }
        service.getPolicyCatalogPorPropiedades(properties, null).subscribe(
            (resp: any) => {
                setLista([]);
                if (resp.DataBeanProperties.ObjectValue) {
                    setLista(resp.DataBeanProperties.ObjectValue);
                }
            }
        );
    }

    return (
        <>
            <label>{titulo}</label>
            <select className="form-select mt-2" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option value={null}>...</option>
                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <>
                                <option key={index} value={item.DataBeanProperties.IDPolicy} >{item.DataBeanProperties.Name}</option>
                            </>)
                    })
                }
            </select>
        </>
    )
}